import request from '@/utils/request'

export default {
  summary(customerId) { return request.get(`/cust/portrait/summary/${customerId}`) },
  marks(customerId) { return request.get(`/cust/portrait/marks/${customerId}`) },
  logs(customerId) { return request.get(`/cust/portrait/logs/${customerId}`) }
}
